import React from 'react'
import Header from '../Components/Header'
import Sidebar from '../Components/Sidebar'
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const Layout = ({ isSignedIn }) => {

    const { payload, toggle } = useSelector((state) => state.seller_panel.User);

    const location = useLocation()

    console.log('signincheck', isSignedIn, location)

    if (!isSignedIn) return <Navigate to='/signin' />

    if (isSignedIn && location.pathname == '/') {
        return <Navigate to="/dashboard" />
    }


    return (
        <div>
            <div className="innerpages">
                <div className="dashboard_pages">
                    <Header />
                    <div className="container custom_container">
                        <div className="row">
                            <div className="innerpages_wid">
                                <Sidebar />
                                <div
                                    className={
                                        toggle
                                            ? "content-sec-inner right_widthset"
                                            : "content-sec-inner"
                                    }
                                >
                                    <Outlet />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Layout